// extracted by mini-css-extract-plugin
module.exports = {"section":"Preference_section__L5Msj","thumbDark":"Preference_thumbDark__7bMNP","thumbLight":"Preference_thumbLight__uc5z4"};